export default "__VITE_ASSET__a6fc8313__"